import axios from "axios";

// Use relative URL to leverage Vite proxy
const API_BASE_URL = '/api/v1';


export const providerLogin = async (credentials) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/login`, credentials, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Login failed:", error.response?.data || error.message);
        throw error.response?.data || { message: "Login failed. Please try again." };
    }
};

// export const consultLogin = async (credentials) => {
//   try {
//     const response = await axios.post(
//       `${API_BASE_URL}/appointment/login`,
//       credentials,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     return response.data;

//   } catch (error) {
//     console.error("Login failed:", error.response?.data || error.message);

//     throw error.response?.data || {
//       message: "Login failed. Please try again.",
//     };
//   }
// };
export const consultLogin = async (credentials) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/appointment/login`,
      credentials,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Login failed:", error.response?.data || error.message);

    // Extract actual backend error properly
    const backendError =
      error.response?.data?.error ||   // { error: "subscription expired" }
      error.response?.data?.message || // if backend sends { message: "" }
      error.message ||                 // fallback
      "Something went wrong";

    throw new Error(backendError);
  }
};

export const getUserById = async (id) => {
    try {
        const response = await fetch(`${API_BASE_URL}/user/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        return await response.json();
    } catch (error) {
        console.error("Failed to fetch user:", error);
        throw error;
    }
};

export async function updateUser(id, payload) {
    const formData = new FormData();

    Object.keys(payload).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
            formData.append(key, payload[key]);
        }
    });

    const response = await fetch(`${API_BASE_URL}/user/${id}`, {
        method: "PATCH",
        body: formData,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error("Backend error:", errorData);
        throw new Error(errorData.error || `Failed to update user: ${response.status}`);
    }

    return await response.json();
}

export const updatePassword = async (id, data) => {
    try {
        const formData = new FormData();
        formData.append("current", data.current);
        formData.append("new", data.new);

        const response = await fetch(`${API_BASE_URL}/user/${id}/password`, {
            method: "PATCH",
            body: formData
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.error || "Password update failed");
        }

        return result;
    } catch (err) {
        throw err;
    }
};
